(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offer-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => {
  document.querySelectorAll('template[data-offer-invitation]').forEach(template => {
   if (template.dataset.initialized) return;
   const section = document.getElementById(template.dataset.sectionTarget);
   if (!section) return;
   template.dataset.initialized = 'true';
   const decorate = () => {
    const holder = section.querySelector('span#mf_button');
    const button = holder?.querySelector('button.mf_button');
    if (!button || holder.querySelector('.offer-invitation')) return;
    const note = template.content.firstElementChild.cloneNode(true);
    note.id = section.id + '-offer-invitation';
    button.before(note);
    const descriptions = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!descriptions.includes(note.id)) descriptions.push(note.id);
    button.setAttribute('aria-describedby', descriptions.join(' '));
   };
   decorate();
   new MutationObserver(decorate).observe(section,{childList:true,subtree:true});
  });
 };
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
